import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../../images/pb_pay_logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faSignOut } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { Container } from '@mui/material';
import { checkForRedirect, useAuth } from '../../contexts/AuthContext';
import axios from 'axios';
import { useWindowSize } from '@react-hook/window-size';
import { CONSTS, SCREEN_WIDTH } from '../../const';
import { Modal } from '@mui/material';
import { logger } from '../../utils/logger';

const SiteHeader = () => {
  const { isAuthenticated, setIsAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [innerWidth, outerWidth] = useWindowSize();
  // Add state for confirmation modal
  const [open, setOpen] = useState(false);
  logger.log('innerWidth', innerWidth);
  logger.log('outerWidth', outerWidth);

  const handleLogout = async () => {
    try {
      let response;
      // setIsAuthenticated(false);
      // Clear localStorage
      localStorage.clear();
      setIsAuthenticated(false);
      // Update auth state

      // Redirect to login page
      // navigate('/login');
      // ===== REAL API INTEGRATION =====
      // FOR REAL API: Uncomment this block and comment out MOCK block above

      response = await axios.post(
        `${process.env.REACT_APP_ONBOARDING_API_ENDPOINT}/graphql`,
        {
          query: `mutation Logout {
            logout {
              status
              statusCode
              errorCode
              message
            }
          }`,
          variables: {},
        },
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const logout = response?.data?.data?.logout;
      if (logout?.status == CONSTS.OK) {
        checkForRedirect(401);
      }
    } catch (err) {
      logger.log(err);
    }
  };

  // Handlers for modal
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleConfirmLogout = () => {
    setOpen(false);
    handleLogout();
  };
  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div
          className="modal-container"
          style={{
            background: '#fff',
            padding: 24,
            borderRadius: 8,
            maxWidth: 320,
            margin: '100px auto',
            textAlign: 'center',
          }}
        >
          <div className="modal-content">
            <p>Are you sure you want to log out?</p>
            <div
              style={{
                marginTop: 24,
                display: 'flex',
                justifyContent: 'center',
                gap: 12,
              }}
            >
              <button
                onClick={handleConfirmLogout}
                style={{
                  background: '#d32f2f',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 4,
                  padding: '8px 16px',
                  marginRight: 8,
                  cursor: 'pointer',
                }}
              >
                Yes, Log Out
              </button>
              <button
                onClick={handleClose}
                style={{
                  background: '#e0e0e0',
                  color: '#333',
                  border: 'none',
                  borderRadius: 4,
                  padding: '8px 16px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Header>
        <div className="wrapper">
          <div className="header-container">
            <Logo className="logo" alt="logo" />
            <div className="right-header">
              <Link
                to={process.env.REACT_APP_GRIEVANCE_API_ENDPOINT}
                target="_blank"
              >
                <button className="need-help-btn">
                  <span>
                    {innerWidth < SCREEN_WIDTH.MOBILE ? (
                      <>
                        {' '}
                        <FontAwesomeIcon icon={faPhone} />
                      </>
                    ) : (
                      <>
                        {' '}
                        <FontAwesomeIcon icon={faPhone} /> Need help?{' '}
                        <span style={{ color: '#0065ff' }}>Contact us</span>
                      </>
                    )}
                  </span>
                </button>
              </Link>
              {isAuthenticated && (
                <button
                  className="need-help-btn"
                  style={{ marginLeft: '10px', cursor: 'pointer' }}
                  onClick={handleOpen}
                >
                  {innerWidth < SCREEN_WIDTH.MOBILE ? (
                    <FontAwesomeIcon icon={faSignOut} />
                  ) : (
                    'Log Out'
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </Header>
    </>
  );
};

const Header = styled.header`
  // Sum of both paddings+ image height

  padding-top: 24px;
  padding-bottom: 27px;
  // padding: 20px 0;
  .logo {
    height: 50px;
    width: auto;
  }
  @media all and (max-width: 768px) {
    padding-top: 14px;
    padding-bottom: 32px;
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0 14px;
    padding: 0;
  }

  button {
    &.need-help-btn {
      border: none;
      padding: 6px 16px 6px 12px;
      border-radius: 100px;
      background: rgba(23, 43, 77, 0.12);
      cursor: pointer;
      color: #253858;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      letter-spacing: 0.196px;
      text-align: center;

      a {
        text-decoration: none;
        color: #0065ff;
      }
    }
  }
`;

export default SiteHeader;
